import { Attribute } from "./models/attributes";
import { SyncMessage } from "./models/synchronizer";
import { User, UserAccountLike, AddressLike, LocationLike } from "./models/index";
import { SyncCommandLike } from "./models/syncCommand";

export type DexieTable = Dexie.Table<any, any>;

export abstract class BaseDatabase extends Dexie
{
    public Attribute: Dexie.Table<Attribute, string>;
    public SyncMessage: Dexie.Table<SyncMessage, number>;
    public SyncCommand: Dexie.Table<SyncCommandLike, number>;
    public User: Dexie.Table<User, number>;
    public UserAccount: Dexie.Table<UserAccountLike, number>;
    public Address: Dexie.Table<AddressLike, number>;
    public Location: Dexie.Table<LocationLike, number>;

    constructor(name: string)
    {
        super(name, {addons: [(<any>window).dexieRelationships]});
        
        this.version(1).stores({
            Attribute: 'key',
            SyncMessage: '++id,timestamp',
            Address: 'id',
            Location: 'id,address_id',
            SyncCommand: 'id',
            User: 'id',
            UserAccount: 'id, location_id -> Location.id, business_id, user_id -> User.id'
        });
    }
}

export type WithAllType<T> = Promise<T[]> | Dexie.Promise<T[]> | T[] | Dexie.Collection<T, any>;
export function arrayOrCollection<T>(targetItems: WithAllType<T>): PromiseLike<T[]>
{
    if (Array.isArray(targetItems))
    {
        return Promise.resolve(targetItems);
    }
    else
    {
        if (targetItems instanceof Promise || targetItems instanceof Dexie.Promise)
        {
            return targetItems;
        }

        return targetItems.toArray();
    }
}